import base from './base'

const getFilters = (apiParams) => {
  return base.get(`/conference_filters`, { params: apiParams }).then(resp => resp.data)
}

export default {
  getFilters: getFilters
}
